import { FormField } from '../types/form';
import { isSelectFieldType } from '../types/guards';

export const prepareFieldForSave = (field: FormField, editedField: FormField): FormField => {
  if (isSelectFieldType(field.field_type)) {
    return prepareSelectFieldForSave(field, editedField);
  }

  if (field.field_type === 'checkbox_with_input') {
    return prepareCheckboxWithInputForSave(field, editedField);
  }

  if (field.field_type === 'logic') {
    return prepareLogicFieldForSave(field, editedField);
  }

  return editedField;
};

export const normalizeFieldOptions = (field: FormField): FormField => {
  if (['dropdown', 'radio', 'checkbox'].includes(field.field_type) && !field.knowledge) {
    if (Array.isArray(field.options)) {
      const optionsObject = field.options.reduce((obj: any, value: string, index: number) => {
        obj[`option${index + 1}`] = value;
        return obj;
      }, {});
        return { ...field, options: optionsObject };
      } else if (typeof field.options === 'object' && field.options !== null) {
        const { layout, ...optionsWithoutLayout } = field.options as any;
      if (layout) {
        return { ...field, options: { ...optionsWithoutLayout, layout } };
      }
    }
  }
  return field;
};

const prepareSelectFieldForSave = (field: FormField, editedField: FormField): FormField => {
  if (editedField.knowledge) {
    return editedField;
  }

  const layout = (editedField.options as any)?.layout;

  const options = Array.isArray(editedField.options)
    ? editedField.options
    : (editedField.options as any)?.customOptions || [];

  const optionsObject = options.reduce((obj: any, value: string, index: number) => {
    obj[`option${index + 1}`] = value;
    return obj;
  }, {} as { [key: string]: string });

  if (layout && (field.field_type === 'radio' || field.field_type === 'checkbox')) {
    (optionsObject as any).layout = layout;
  }

  return {
    ...editedField,
    options: optionsObject
  };
};

const prepareCheckboxWithInputForSave = (field: FormField, editedField: FormField): FormField => {
  const options = editedField.options as any;
  const inputType = options?.inputType || 'text';
  const inputPlaceholder = options?.inputPlaceholder || 'Enter value';

  if (editedField.knowledge) {
    return {
      ...editedField,
      options: {
        ...options,
        inputType,
        inputPlaceholder
      }
    };
  }

  const customOptions = options?.customOptions || [];
  const optionsObject = customOptions.reduce((obj: any, value: string, index: number) => {
    obj[`option${index + 1}`] = value;
    return obj;
  }, {});

  return {
    ...editedField,
    options: {
      ...optionsObject,
      inputType,
      inputPlaceholder
    }
  };
};

const prepareLogicFieldForSave = (field: FormField, editedField: FormField): FormField => {
  return editedField;
};